// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';

import { API } from './API.js';
import axios from 'axios';

// const url = WEBSERVER + ':3000/api/wineries/';
// const url = WEBSERVER + ':' + PORT + '/api/wineries/';

const url = API + '/wineries/';
const debug = false;

class Wineries {
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(winery=> ({
                        ...winery,
                        name: winery.name
                    }))
                );
                if (debug) console.log("Wineries.get: data = " + data)
            } catch(err) {
                reject(err);
            }
        })
    }

    // get one winery
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Wineries.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Wineries.getone: ',error)
            })
    }

    static create(postdata) {
        if (debug) console.log('Wineries.create: postdata = ',postdata)
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Wineries.create: response = ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Wineries.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Wineries.update: id=',id)
        if (debug) console.log('Wineries.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Wineries.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Wineries.update: ',error)
            })
    }

    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default Wineries